// @codekit-prepend "lib/share.js"

(function(){
    $(document).on('contentAdded', (event, content) => {
        content = $(content)
        content.find('.share-buttons .facebook').on('click', share.facebook);
        content.find('.share-buttons .twitter').on('click', share.twitter);
        content.find('.share-buttons .email').on('click', share.email);
    });
})()
